import { renderTextBlock } from '../render/blocks/text';
import { TextBlockSettings } from '../settings/blocks/text';
import { defineBlockRegistryEntry } from './defineEntry';
import { textBlockDefinition } from '../domain/blocks/text';

export const textBlockRegistryEntry = defineBlockRegistryEntry(
  textBlockDefinition,
  renderTextBlock,
  TextBlockSettings,
);
